import {
  Copy,
  Flex,
  Heading,
  Square,
  Stack,
  SvgCaretDown,
} from '@grubhubprod/gh-cookbook-react/dist';
import React, { ReactNode } from 'react';

export interface IMenuItemContentProps {
  menu: string;
  icon?: ReactNode;
  hasSubRoutes?: boolean;
}

export function MenuItemContent({
  menu,
  icon,
  hasSubRoutes,
}: IMenuItemContentProps): JSX.Element {
  return (
    <Flex alignItems="center">
      <Square
        inset="md"
        className="navBarLink"
        tabIndex={0}
        color="primaryText"
        display="flex"
        alignItems="center"
      >
        {!!icon && <Stack x="x-sm">{icon}</Stack>}
        <Heading variant="h6">{menu}</Heading>
      </Square>
      {hasSubRoutes && (
        <Copy variant="body" color="secondaryText">
          <SvgCaretDown size="16px" aria-label="Open dropdown" />
        </Copy>
      )}
    </Flex>
  );
}
